export type AggregationType =
    "First"
    | "Last"
    | "Min"
    | "Max"
    | "Sum"
    | "Count"
    | "Average"
    | "Percentile"
    | "Slope"
    | "StandardDeviation"
    ;

